import React from 'react';

function renderCell(value) {
    if (Array.isArray(value)) {
        // ถ้าเป็น array ของ object ให้สร้าง header แค่ครั้งเดียว
        if (value.length > 0 && typeof value[0] === 'object' && value[0] !== null && !Array.isArray(value[0])) {
            const keys = Object.keys(value[0]);
            return (
                <table className="json-to-table" border="1" cellPadding="3" style={{ borderCollapse: 'collapse', margin: '5px 0' }}>
                    <thead>
                        <tr>
                            {keys.map(k => <th key={k}>{k}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {value.map((item, idx) => (
                            <tr key={idx}>
                                {keys.map(k => <td key={k}>{renderCell(item[k])}</td>)}
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
        } else {
            // array ของ primitive หรือ array ซ้อน
            return (
                <table className="json-to-table" border="1" cellPadding="3" style={{ borderCollapse: 'collapse', margin: '5px 0' }}>
                    <tbody>
                        {value.map((item, idx) => (
                            <tr key={idx}>
                                <td>{renderCell(item)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
        }
    } else if (typeof value === 'object' && value !== null) {
        const keys = Object.keys(value);
        return (
            <table className="json-to-table" border="1" cellPadding="3" style={{ borderCollapse: 'collapse', margin: '5px 0' }}>
                <tbody>
                    <tr>
                        {keys.map(k => (
                            <td key={k}><strong>{k}</strong></td>
                        ))}
                    </tr>
                    <tr>
                        {keys.map(k => <td key={k}>{renderCell(value[k])}</td>)}
                    </tr>
                </tbody>
            </table>
        );
    } else if (typeof value === 'string') {
        const html = value
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/\n/g, "<br>");
        return <span dangerouslySetInnerHTML={{ __html: html }} />;
    } else {
        return value !== null ? value.toString() : '';
    }
}



function JsonToTable({ data }) {
    const rows = Array.isArray(data) ? data : [data];
    const columns = Array.from(
        new Set(rows.flatMap(row => Object.keys(row)))
    );

    return (
        <table className="json-to-table" border="1" cellPadding="5" style={{ borderCollapse: 'collapse' }}>
            <thead>
                <tr>
                    {columns.map(col => (
                        <th key={col}>{col}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, idx) => (
                    <tr key={idx} className={idx % 2 === 0 ? 'even' : 'odd'}>
                        {columns.map(col => (
                            <td key={col}>{renderCell(row[col])}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}


export default JsonToTable;
